export * from "@vaadin/avatar-group/vaadin-avatar-group.js";
export * from './generated/AvatarGroup.js';
